// extracted by mini-css-extract-plugin
export var connectionButton = "_b2-1";
export var rightPanel = "_b2-3";
export var stepDescription = "_b2-2";
export var stepIcon = "_b2-0";